import {
  isMobile,
  _s,
  postFetcherWithResponse,
  getFetcherWithResponse
} from '@startlibs/utils'
import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash/fp';
import styled, { css } from 'styled-components'
import { PurviewFooter } from '../components/PurviewFooter'
import { stickyOnDesktop } from '../utils/stickyOnDesktop';
import { CardActionButton, CardHeader, SignInCard, SignInLayout, SystemLogo } from '../components/SigninLayout';
import { Errors, TextInput,  WithForm } from '@startlibs/form';
import { buildValidation, minLength, required } from '../utils/validation';
import { Icon } from '@startlibs/components';
import { navigate } from '@reach/router';
import { setRefreshToken } from '../hooks/useRefresh';
import { fetchWithTokenRefresh, useAuth } from '../providers/AuthContext';
import { MENU_ITEMS } from '../utils/constants';
import { setJwt } from '../hooks/useJwt';
import { setNotification } from '../components/Notifications';
import { SESSION_EXPIRED_MSG } from '../utils/utils';
import { LoadingPage } from '../components/PageLoading';
import HeaderComponent from '../components/HeaderComponent';

const preValidation = buildValidation({ username: [required], password: [required, minLength(8)] })

const FooterContainer = styled.div`
  ${props => !props.isMobile && css`
    min-width: ${props => props.visibleColumnsAmount > 8 ? '115rem' : '100rem'};
  `}
`
const UserlistPurviewFooter = styled(PurviewFooter)`
  ${stickyOnDesktop()}
  margin-left: 0;
  margin-right: 0;
`

export const PasswordVisibilityButton = styled(Icon)`
  position: absolute;
  right: 1rem;
  bottom: 5px;
  font-size: 24px;
  color: rgba(0,0,0,0.5);
  cursor: pointer;
  :hover {
    color: rgba(0,0,0,0.75);
  }
`

const Container = styled.div`position:relative;`

const NeedSupport = styled.div`
  max-width: 36rem;
  margin: 18px auto;
  text-align: center;
  font-size: 13px;
`

export const PasLogin = () => {

  const {loadedData, instanceData, setMenu, setAuthUser, setPacsDbName, setIsCheckingAuth} = useAuth()
  const defaultLogoURL = '/spa/public/purview-logo.png'

  const title = instanceData?.title || 'Purview Image - Login'
  const { isCheckingAuth } = useAuth()

  

  useEffect(() => {
    document.title = title
  }, [title])

  useEffect(() => {
    try {

      const urlPath = window.location.pathname
      
      // Helper function to get URL parameters
      const getURLParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
      };


      // Retrieve tokens from URL params or localStorage
      const jwtFromURL = (urlPath === '/instantshare' || urlPath === '/instantshare.php' || urlPath === '//instantshare' || urlPath === '//instantshare.php') ? false : getURLParam('jwt');
      // Do not set jwt token when it is a share link
      
      const refreshTokenFromURL = getURLParam('refreshToken') || getURLParam('refresh');

      const jwt = jwtFromURL || window.localStorage.getItem('worklist-jwt')
      if (jwt) {
        setJwt(jwt, 'worklist')
      }
      const refreshToken = refreshTokenFromURL || window.localStorage.getItem('refreshToken')
      if (refreshToken) {
        setRefreshToken(refreshToken, 'refreshToken')
      } else {
        setRefreshToken('')
      }

      setIsCheckingAuth(true)
      const path = window.location.pathname
      
      fetchWithTokenRefresh(
          getFetcherWithResponse,
          '/gw/worklist/options-and-rights',
          {},
          {},
          { jwt: jwt, refreshToken: refreshToken },
          'login',
          false
      ).then(([data, res]) => {
        // Filter the menus based on the presence of the name in data.auth array
        let availableMenuItens = MENU_ITEMS.filter(item => data.menus.includes(item.name));
        const isCustodianOfRecords = data?.options?.custodian || false
        const userLogin = data?.username || ''
        const isPurviewUser = userLogin.toLowerCase().endsWith('@purview.net') || userLogin.includes('purview@')

        if(isCustodianOfRecords && !isPurviewUser){
          availableMenuItens = availableMenuItens.filter(item => {
            return item.name !== 'reports' && item.name !== 'auditLogs' && item.name !== 'userManagement'
          })
        }
        setMenu(availableMenuItens)
        setAuthUser(data?.username)
        setPacsDbName(data?.pacsdbname)
        // window.location.href = '/'
        // console.log('success. Now is navigating to /')
        navigate('/')
        
        setIsCheckingAuth(false)
        return
      }).catch((error) => { 
        console.error(error)
        setIsCheckingAuth(false)
      })

    } catch (error) {
      console.error(error)
      setIsCheckingAuth(false)
    }

  }, [setMenu, setAuthUser, setPacsDbName, setIsCheckingAuth])

  if (isCheckingAuth) {
    return <><LoadingPage /></>
  }
  return <>
    {/* <HeaderComponent /> */}
  </>
}